<template>
    <div class="technian-record">
        <baseInfoWrap title="JI SHI DANG AN" :useBorder="false" titleColor="#d3d5da" textColor="#e9eaed">
            <table class="technian-record-table">
                <tr class="row-type1">
                    <td class="row-title">
                        <p>{{ technianRecordData[0].title }}</p>
                    </td>
                    <td class="row-content">
                        <p>{{ technianRecordData[0].content }}</p>
                    </td>
                    <td class="row-title">
                        <p>{{ technianRecordData[1].title }}</p>
                    </td>
                    <td class="row-content">
                        <p>{{ technianRecordData[1].content }}</p>
                    </td>
                </tr>
                <tr class="row-type1">
                    <td class="row-title">
                        <p>{{ technianRecordData[2] ? technianRecordData[2].title : '' }}</p>
                    </td>
                    <td class="row-content">
                        <p>{{ technianRecordData[2] ? technianRecordData[2].content : '' }}</p>
                    </td>
                    <td class="row-title">
                        <p>{{ technianRecordData[3] ? technianRecordData[3].title : '' }}</p>
                    </td>
                    <td class="row-content">
                        <p>{{ technianRecordData[3] ? technianRecordData[3].content : '' }}</p>
                    </td>
                </tr>
                <tr class="row-type2" v-for="(item, index) in technianRecordArray" :key="index">
                    <td class="row-title" colspan="2">
                        <p>{{ item.title || '' }}</p>
                    </td>
                    <td class="row-content" colspan="2">
                        <p>{{ item.content || '' }}</p>
                    </td>
                </tr>
                <tr class="row-type3">
                    <td class="row-title" colspan="2">
                        <p>簡介</p>
                    </td>
                    <td class="row-desc" colspan="2">
                        <p>{{ originData.desc || '' }}</p>
                    </td>
                </tr>
            </table>
        </baseInfoWrap>
    </div>
</template>

<script>
import baseInfoWrap from './base/baseInfoWrap.vue';
export default {
    components: { baseInfoWrap },
    props: {
        originData: {
            type: Object,
            default: () => { }
        }
    },
    computed: {
        technianRecordData() {
            return this.originData && this.originData.technianRecordData ? this.originData.technianRecordData : [];
        },
        technianRecordArray() {
            return this.technianRecordData.slice(4);
        }
    }
}
</script>

<style lang="scss" scoped>
.technian-record {
    height: 100%;

    .technian-record-table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        .row-title {
            background-color: #f2f2f4;

            p {
                font-weight: bold;
            }
        }

        .row-content,.row-desc {
            p {
                color: #404040;
            }
        }

        .row-desc{
            padding: .15rem;
        }

        td {
            border-color: #d3d5da;
            border-style: solid;
            border-width: 1px;

            p {
                font-size: .24rem;
                text-align: center;
            }
        }

        .row-type1 {
            td {
                width: 25%;
                height: .42rem;

            }
        }

        .row-type2 {
            td {
                width: 50%;
                height: .42rem;
            }
        }
    }
}</style>